module.exports = __webpack_public_path__ + "473bdec68973e68d0e41ec55212a6d8a.png";